import React from 'react';
import PropTypes from 'prop-types';
import { formatDate } from '../../../../utils/helpers/formatters';
import './styles.scss';
const PositiveResponse = ({positiveResponse}) => {
    // Support both snake_case and camelCase for backwards compatibility
    const {
      contact_type,
      contact_result,
      email_to,
      email_subject,
      email_body,
      metadata_date,
      contactType,
      contactResult,
      emailTo,
      emailSubject,
      emailBody,
      metadata,
    } = positiveResponse

    // Use camelCase if available, fallback to snake_case
    const contactTypeValue = contactType || contact_type;
    const contactResultValue = contactResult || contact_result;
    const emailToValue = emailTo || email_to;
    const emailSubjectValue = emailSubject || email_subject;
    const emailBodyValue = emailBody || email_body;
    const metadataDateValue = metadata?.date || metadata_date;

    return (
      <div className={'positive-response'}>
        <div className={'positive-response-header'}>
          Positive Response {formatDate(metadataDateValue)}
        </div>
        <div className={'response'}>
          {contactTypeValue === 'email' && (
            <React.Fragment>
              <div><b>Status</b>: {contactResultValue}</div>
              <div><b>Contact Type</b>: {contactTypeValue}</div>
              <div><b>To</b>: {emailToValue}</div>
              <div><b>Subject</b>: {emailSubjectValue}</div>
              <div><b>Body</b>: {emailBodyValue}</div>
            </React.Fragment>
          )}
          {contactTypeValue === 'phone' && (
            <React.Fragment>
              <div>status: {contactResultValue}</div>
              <div>Contact Type: {contactTypeValue}</div>
            </React.Fragment>
          )}
        </div>
      </div>
    );
  }

PositiveResponse.propTypes = {
  positiveResponse: PropTypes.object.isRequired,
};

export default PositiveResponse;
